import { useState } from 'react'
import contactValidator from './contact.validator';
import { toast } from 'react-toastify';
// import the emailjs module
import emailjs from '@emailjs/browser'

const INITIAL_STATE = {
    name: "",
    email: "",
    business: "",
    message: ""
}

export default function useContactForm() {
    const [form, setForm] = useState(INITIAL_STATE);
    const [submitted, setSubmitted] = useState(false);
    const [errors, setErrors] = useState({}) // initial state is an object

    const handleChange = (e) => {
        // Destructure the name and the value
        const { name, value } = e.target

        setForm((prev) => ({
            // spread all the previous data
            ...prev,
            [name]: value
        }))

        // if the error key 
        if (errors[name]) {
            setErrors((prev) => ({
                // spread the previous errors
                ...prev,
                [name]: ''
            }))
        }
    };
    
    // Store the errors in a variable if any
    const validationErrors = contactValidator(form)

    const handleSubmit = async (e) => {
        // prevent the default form behavior
        e.preventDefault()

        // if there are any errors, exit the function immediately and display those errors
        if (Object.keys(validationErrors).length > 0) {
            // update the errors function with an error
            setErrors(validationErrors)
            // Exit the function
            return
        }

        try {
            setSubmitted(true);

            await emailjs.send(
                process.env.REACT_APP_EMAIL_JS_SERVICE_ID,
                process.env.REACT_APP_EMAIL_JS_TEMPLATE_ID,
                {
                    from_name: form.name,
                    from_email: form.email,
                    business_name: form.business,
                    message: form.message
                },
                process.env.REACT_APP_EMAIL_JS_PUBLIC_ID
            )

            toast.success("Email submitted successfully 🎉🎉\nWe'll get back to you within 24hrs")
            // end the form submission
            setSubmitted(false);
            // set the form back to it's initial state
            setForm(INITIAL_STATE)

        } catch(err) {
            console.error('Error submitting the form: ', err.message)
            toast.error('Something went wrong please try again')
        } finally {
            setSubmitted(false)
        }
    };

    return {
        handleChange,
        form,
        handleSubmit,
        submitted,
        errors
    }
}
